const colors = {
	greenLime1: "#C5FF01",
	greenLime2: "#B4E900",
	greenLime3: "#9ECC01",
	greenLime4: "#8DB700",
	greenLime5: "#81A700",
	greenDark: "#004B23",

	purple: "#7512FF",

	red1: "#EA243E",
	red2: "#A8172A",

	grey1: "#F8F9FA",
	grey2: "#E9ECEF",
	grey3: "#DEE2E6",
	grey4: "#CED4DA",
	grey5: "#ADB5BD",
	grey6: "#6C757D",
	grey7: "#495057",
	grey8: "#343A40",
	grey9: "#212529",
	grey10: "#0F1112",
	black: "#0A0A0A"
};

export default colors;
